<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      title="افزودن کاربر جدبد"
      :no-close-on-backdrop="true"
      hide-header-close
      size="md"
  >
    <div class="mb-2 mt-2">
      <h4>کاربران مدیر</h4>
      <div class="border mb-1 p-1 position-relative">
        <b-form-group label="کاربر" class="flex-grow-1">
          <user-select v-model="adminUserId" @change="handleAdminUsers" />
        </b-form-group>
        <div>
          <b-badge v-for="user in adminUsers" :key="user.UserId" class="mr-1 mb-1">
            <span v-text="user.Name" />
            <feather-icon
                icon="XIcon"
                class="ml-1"
                @click="removeUser(user, true)"
            />
          </b-badge>
        </div>
      </div>
    </div>
    <div>
      <h4>کاربران</h4>
      <div class="border mb-1 p-1 position-relative">
        <b-form-group label="کاربر" class="flex-grow-1">
          <user-select v-model="userId" @change="handleUsers" />
        </b-form-group>
        <div>
          <b-badge v-for="user in users" :key="user.UserId" class="mr-1 mb-1">
            <span v-text="user.Name" />
            <feather-icon
                icon="XIcon"
                class="ml-1"
                @click="removeUser(user)"
            />
          </b-badge>
        </div>
      </div>
    </div>
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="disabled"
            @click="submit"
        >
          ذخیره
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import UserSelect from "@/tools/user.vue";
export default {
  name: "MessageGroupUserForm",
  props: {
    show: { type: Boolean, default: false },
    messageGroupId: { type: [String, Number], default: '' },
  },
  components: { UserSelect },
  data() {
    return {
      loading: false,
      adminUsers: [],
      users: [],
      userId: '',
      adminUserId: '',
    }
  },
  computed: {
    disabled() {
      return ![...this.users, ...this.adminUsers].length
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.users = []
          this.adminUsers = []
        }
      }
    },
  },
  methods: {
    submit() {
      this.loading = true
      let data = {
        MessageGroupId: this.messageGroupId,
        groupUsers: [...this.users, ...this.adminUsers]
            .map(({ UserId, UserRole }) => {
              return { UserId, UserRole }
            })
      }

      this.$http.post(this.$api.messenger.addMessageGroupUser, data)
          .then(() => {
            this.loading = false
            this.$emit('update:show', !this.show)
            this.$emit('done')
          }).catch(() => {
        this.loading = false
      })
    },
    handleAdminUsers(user) {
      let isExist = this.adminUsers.findIndex(item => item.UserId === user.Id)
      if (isExist === -1)
        this.adminUsers.push({
          Name: user.Name,
          UserId: user.Id,
          UserRole: 0,
        })
      this.$nextTick(() => {
        this.adminUserId = ''
      })
    },
    handleUsers(user) {
      let isExist = this.users.findIndex(item => item.UserId === user.Id)
      if (isExist === -1)
        this.users.push({
          Name: user.Name,
          UserId: user.Id,
          UserRole: 1,
        })
      this.$nextTick(() => {
        this.userId = ''
      })
    },
    removeUser(user, isAdmin = false) {
      let index = null
      if (isAdmin) {
        index = this.adminUsers.findIndex(item => item.UserId === user.UserId)
        if (index !== -1) this.adminUsers.splice(index, 1)
      } else {
        index = this.users.findIndex(item => item.UserId === user.UserId)
        if (index !== -1) this.users.splice(index, 1)
      }
    }
  }
}
</script>